import React from 'react';
import { useDocumentTitle } from '../../../hooks/use-document-title';
import {
  ContentAndButtonsContainer,
  NavbarAndContentContainer,
} from '../../../layout/layout-container.styled';
import { ScreenHeader } from '../../../layout/page-header';
import { DefaultComponentProps } from '../../../app-router/component-props';
import { DashboardPasses } from '../../dashboard/dashboard-passes-components/dashboard-passes';
import { Card, Empty } from '../../visitor-exit/visitor-exit-page.styled';
import { ExpectedBody } from '../expected/expected-page.styled';

/**
 * VISITOR PASSES AT THE DESK — every pass at the desk's building, residents'
 * and the building's alike (owner decision 2026-09-29, "the front desk should
 * see the pass register"). /visitor-log/passes, reached from Expected today.
 *
 * The SAME register the managers use (DashboardPasses), pinned to the building
 * the desk is working in: no building picker (the desk's building is chosen at
 * the desk gate), and no on/off switch — that stays visitorpass:manage, which a
 * concierge does not hold. What the desk may do on a row (Pause / Resume / End)
 * is what the server says on each pass (`can_edit` / `can_end`, from the
 * building's concierge_pass_access setting, migration 118); reading needs only
 * visitorpass:read, which GET /buildings/:b/passes already checks.
 *
 * A standalone route under /visitor-log, like Expected today: it sits in the
 * desk shell and gets the building context, and ROUTE_PERMISSIONS gates it on
 * visitorpass:read (app-router.tsx).
 */
export const DeskPassesPage: React.FC<DefaultComponentProps> = ({ selectedBuilding }) => {
  useDocumentTitle('Visitor passes');
  const buildingId = Number(selectedBuilding?.id) || null;
  const name = selectedBuilding?.property_name || '';

  return (
    <NavbarAndContentContainer>
      <ContentAndButtonsContainer>
        <ExpectedBody>
          <ScreenHeader
            title="Visitor passes"
            subtitle={name || 'No building selected'}
            backTo="/visitor-log/expected"
            backLabel="Back to Expected today"
          />
          {buildingId ? (
            <DashboardPasses fixedBuilding={{ id: buildingId, name }} />
          ) : (
            <Card>
              <Empty>Choose a building at the desk to see its visitor passes.</Empty>
            </Card>
          )}
        </ExpectedBody>
      </ContentAndButtonsContainer>
    </NavbarAndContentContainer>
  );
};
